// extracted by mini-css-extract-plugin
export default {"popover":"index_popover__d80q8","btnText":"index_btnText__lc4ZM"};